// Dashboard KPI tiles. No dedicated /stats endpoint yet — derive counts from
// list APIs (limit=1, read meta.total). Cheap because mongo indexes the filters.

import { Card, Col, Row, Statistic, Typography } from 'antd';
import { useCustomers } from '../features/customers/useCustomers';
import { useLicenses } from '../features/licenses/useLicenses';

const { Title } = Typography;

export function DashboardPage() {
  const customers = useCustomers({ page: 1, limit: 1, sort: '-createdAt' });
  const allLicenses = useLicenses({ page: 1, limit: 1, sort: '-createdAt' });
  const active = useLicenses({ page: 1, limit: 1, status: 'active' });
  const expired = useLicenses({ page: 1, limit: 1, status: 'expired' });
  const revoked = useLicenses({ page: 1, limit: 1, status: 'revoked' });

  return (
    <>
      <Title level={3} style={{ marginTop: 0 }}>Dashboard</Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card loading={customers.isLoading}>
            <Statistic title="Customers" value={customers.data?.meta.total ?? 0} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card loading={allLicenses.isLoading}>
            <Statistic title="Licenses (tổng)" value={allLicenses.data?.meta.total ?? 0} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card loading={active.isLoading}>
            <Statistic title="Active" value={active.data?.meta.total ?? 0} valueStyle={{ color: '#3f8600' }} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card loading={expired.isLoading}>
            <Statistic title="Expired" value={expired.data?.meta.total ?? 0} valueStyle={{ color: '#cf1322' }} />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Card loading={revoked.isLoading}>
            <Statistic title="Revoked" value={revoked.data?.meta.total ?? 0} valueStyle={{ color: '#d4380d' }} />
          </Card>
        </Col>
      </Row>
    </>
  );
}
